import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get, pick } from 'lodash';
import type { CreateAssetTypeMutation, AssetTypeInput } from '#/graphql/types';
import { createAssetType } from '#/graphql/mutations';
import fields from '../utils/mutationDataFields';
import { inUseStatuses } from '../components/AssetType.Mappings';

const q = gql(createAssetType);

const useAssetTypeCreate = () => {
  const [mutation, result] = useMutation<CreateAssetTypeMutation>(q);
  const createAssetType = useCallback(
    async (assetType: AssetTypeInput) => {
      const response = await mutation({
        variables: {
          data: {
            ...pick(assetType, fields),
            inUseStatus: assetType.inUseStatus ?? inUseStatuses.newlyCreated.key,
          },
        },
      });
      return get(response, 'data.createAssetType', undefined);
    },
    [mutation],
  );

  return { createAssetType, result };
};

export default useAssetTypeCreate;
